import React from 'react';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-obsidian text-white" data-id="element-82" data-mp="3gezcj1s77n03">
      <div className="mx-auto max-w-4xl px-5 py-14 text-center" style={{
      paddingTop: "22px",
      paddingBottom: "15px"
    }} data-id="element-83" data-mp="3ghc4m7ro7dqv">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-aqua" data-id="element-84" data-mp="36pfufycb7x6a">Sigma Smart™</p>
        <p className="mt-3 font-display text-3xl font-extrabold uppercase leading-none" data-id="element-85" data-mp="3uf0obca04euc">
          The Full Distance Triathlon System™
        </p>
        <p className="mt-3 text-sm font-semibold uppercase tracking-wider text-white/70" data-id="element-86" data-mp="37fsp0xcko14">
          Train smarter. Fuel better. Execute with confidence.
        </p>
        <p className="mt-2 text-sm text-white/50" data-id="element-87" data-mp="3qd6rjf2xfuzg">
          One system to organize the entire journey from training to finish line.
        </p>

        <a href="mailto:soporte.sigmasmart@gmail.com" className="mt-8 inline-flex items-center gap-2 text-sm text-white/75 transition-colors duration-150 ease-out hover:text-white" data-id="element-88" data-mp="29xlzsm95j0i1">
          <MailIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-89" data-mp="3lalg1f31y5ty" /> soporte.sigmasmart@gmail.com
        </a>

        <nav aria-label="Legal" className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/45" data-id="element-90" data-mp="3gc0hdk3g7u7m">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-91" data-mp="3v5n7ihksvjzp">Terms & Conditions</a>
          <span aria-hidden="true" data-id="element-92" data-mp="3qazo2x4nlfrz">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-93" data-mp="81ywcgswhu2x">Privacy Policy</a>
          <span aria-hidden="true" data-id="element-94" data-mp="335s7ezi7fff">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-95" data-mp="3230x5y9rayz">Support</a>
        </nav>

        <p className="mt-8 text-xs text-white/35" data-id="element-96" data-mp="cu0geowb8p3i">© 2026 SIGMA SMART™ — All Rights Reserved</p>
      </div>
    </footer>;
}